import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: 'Inicio' },
    { to: '/empresa', label: 'Empresa' },
    { to: '/servicios', label: 'Servicios' },
    { to: '/faq', label: 'Preguntas Frecuentes' },
    { to: '/contacto', label: 'Contacto' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 flex-shrink-0">
            <div className="bg-primary rounded-lg p-2 flex items-center justify-center">
              <i className="ri-delete-bin-line text-2xl text-white"></i>
            </div>
            <div className="flex flex-col">
              <span
                className={`font-bold text-lg sm:text-xl leading-tight transition-colors ${
                  isScrolled ? 'text-dark' : 'text-white'
                }`}
              >
                JUSTCLEAN VIC
              </span>
              <span
                className={`text-xs leading-tight transition-colors ${
                  isScrolled ? 'text-gray-600' : 'text-white/90'
                }`}
              >
                Vaciado de pisos
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                  location.pathname === link.to
                    ? isScrolled
                      ? 'bg-primary text-white'
                      : 'bg-white/20 text-white'
                    : isScrolled
                    ? 'text-dark hover:bg-gray-100'
                    : 'text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button Desktop */}
          <div className="hidden lg:block flex-shrink-0">
            <a
              href="tel:+34602365996"
              className="bg-primary text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-red-700 transition-all duration-300 shadow-lg text-sm whitespace-nowrap inline-flex items-center cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              602 36 59 96
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors flex-shrink-0 ${
              isScrolled ? 'text-dark hover:bg-gray-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg max-h-screen overflow-y-auto">
          <div className="px-4 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? 'bg-primary text-white'
                    : 'text-dark hover:bg-gray-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+34602365996"
              className="block bg-primary text-white px-4 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors text-sm text-center cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              602 36 59 96
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
